import { lightColors as colors } from "@common/consts/colors";
import { EventEmitter } from "eventemitter3";
import JSConfetti from "js-confetti";
import { useEffect, useRef } from "react";

export const ConfettiEvents = new EventEmitter<{ ADD_CONFETTI: () => void }>();

export function useConfetti() {
  const confettiRef = useRef<JSConfetti | null>(null);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const canvas = createCanvas();
    const jsConfetti = new JSConfetti({
      canvas,
    });

    function createCanvas() {
      var canvas = document.createElement("canvas");
      canvas.style.position = "fixed";
      canvas.style.width = "100%";
      canvas.style.height = "100%";
      canvas.style.top = "0";
      canvas.style.left = "0";
      canvas.style.zIndex = "99999999";
      canvas.style.pointerEvents = "none";
      document.body.appendChild(canvas);
      return canvas;
    }

    confettiRef.current = jsConfetti;

    ConfettiEvents.on("ADD_CONFETTI", () => confettiRef.current?.addConfetti());
    return () => {
      document.body.removeChild(canvas);
    };
  }, []);
}
